<ion-content>
  <div class="flex-container">
    <div class="left-column header-row">
      <div class="ion-text-start header-title">
        {{ title | translate}}
      </div>
    </div>
    <div class="right-column">
      <img class="close-icon" alt="" tooltip="{{'Close'  | translate }}" placement="bottom" (click)="closeModal()" src="assets/icon/cancel.svg">
    </div>
  </div> 
  <div class="main-content">
    <ion-row>
      <ion-col>
        <ion-label class="cc-label"> {{'Section Name' | translate }} *</ion-label>
        <div class="file-input">
          <ion-input [ngModel]="currentName" [readonly]="true" placeholder="{{'Enter Name'| translate }}" class="input-label disabled"></ion-input>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-label class="cc-label"> {{'new_name' | translate }} *</ion-label>
        <div class="file-input">
          <ion-input [(ngModel)]="section.changedName" placeholder="{{'Enter Name'| translate }}" class="input-label"></ion-input>
        </div>
      </ion-col>
    </ion-row>
    <div class="save-button">
      <ion-button [disabled]="!section.changedName.trim()" class="app-btn" shape="round" fill="outline" color="primary" (click)="submit()">
        {{'Save'|translate}}
      </ion-button>
      <ion-button class="app-btn margin-right-16" shape="round" fill="outline" color="primary" (click)="cancel()">
        {{'Cancel'|translate}}
      </ion-button>
    </div>
  </div>
</ion-content>
